import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { cx } from '@wp-g2/styles';
import React from 'react';
import { CompositeItem } from 'reakit';
import { Tooltip } from '../Tooltip';
import { VisuallyHidden } from '../VisuallyHidden';
import * as styles from './AlignmentMatrixControl.styles';
import { ALIGNMENT_LABEL } from './constants';
var CellView = styles.CellView,
    PointView = styles.PointView;

function AlignmentMatrixControlCell(_ref) {
  var _cx;

  var id = _ref.id,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["id", "isActive", "value"]);

  var tooltipText = ALIGNMENT_LABEL[value];
  var pointClasses = cx((_cx = {}, _cx[styles.activePoint] = isActive, _cx));
  return /*#__PURE__*/React.createElement(CompositeItem, Object.assign({
    as: CellView,
    role: "gridcell"
  }, props, {
    id: id
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, value), /*#__PURE__*/React.createElement(Tooltip, {
    baseId: id,
    content: tooltipText,
    focusable: false
  }, /*#__PURE__*/React.createElement(PointView, {
    className: pointClasses,
    role: "presentation"
  })));
}

export default /*#__PURE__*/React.memo(AlignmentMatrixControlCell);